export default __webpack_public_path__ + "static/media/search.cbdbe0de.svg";